import Alpine from '@alpinejs/csp'
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import { z } from 'zod';
import registerNewsletterComponent from './newsletter-component';
import registerMediaCarousels from './media-carousel';

window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(focus);

registerNewsletterComponent(Alpine, z);

Alpine.store('toc', {
    _visible: [],
    _items: [],
    register(id, title) {
        if (!this._items.some(function(i) { return i.id === id; })) {
            this._items.push({ id: id, title: title });
        }
    },
    add(id) {
        if (!this._visible.includes(id)) this._visible.push(id);
    },
    remove(id) {
        this._visible = this._visible.filter(function(v) { return v !== id; });
    },
    get items() { return this._items; },
    get active() {
        for (var i = 0; i < this._items.length; i++) {
            if (this._visible.includes(this._items[i].id)) return this._items[i].id;
        }
        return '';
    }
});

Alpine.data('tocSection', (id, title) => ({
    shown: false,
    init() {
        Alpine.store('toc').register(id, title);
        var self = this;
        var margin = window.matchMedia('(min-width: 1806px)').matches ? '0px' : '-48px 0px 0px 0px';
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) { self.show(); }
                else { self.hide(); }
            });
        }, { rootMargin: margin });
        observer.observe(self.$el);
    },
    show() {
        this.shown = true;
        Alpine.store('toc').add(id);
    },
    hide() {
        Alpine.store('toc').remove(id);
    },
}));

Alpine.data('spaHeader', () => ({
    open: false,
    onDark: false,
    init() {
        var self = this;
        var nav = this.$refs.nav;
        var floating = window.matchMedia('(min-width: 1806px)');
        var pending = false;
        // The dark surfaces are marked with data-nav-dark in the markup. They all run the full
        // width of the page, so overlapping the nav's vertical span is enough.
        function check() {
            pending = false;
            if (!floating.matches) { self.onDark = false; return; }
            var rect = nav.getBoundingClientRect();
            self.onDark = Array.from(document.querySelectorAll('[data-nav-dark]')).some(function(el) {
                var dark = el.getBoundingClientRect();
                return dark.top < rect.bottom && dark.bottom > rect.top;
            });
        }
        function schedule() {
            if (!pending) { pending = true; requestAnimationFrame(check); }
        }
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        schedule();
    },
    // Object form so Alpine removes the classes again. bg-tertiary/0 rather than transparent
    // so the fade stays in the cream instead of passing through grey.
    get navClass() {
        return {
            'block': this.open,
            'hidden': !this.open,
            'min-[1806px]:bg-tertiary/55': this.onDark,
            'min-[1806px]:bg-tertiary/0': !this.onDark
        };
    },
    toggle() { this.open = !this.open; },
    close() { this.open = false; },
}));

Alpine.data('insight', () => ({
	open: false,		
	toggleModal() {
		if (this.open) {
			this.closeModal();
		}
		else {
			this.openModal();
		}
	},
	openModal() {
		this.open = true;
		document.body.classList.add('overflow-hidden');
	},
	closeModal() {
		this.open = false;
		document.body.classList.remove('overflow-hidden');
	}
}));

Alpine.data('question', () => ({
    open: false,
    toggleModal() {
        if (this.open) {
            this.closeModal();
        }
        else {
            this.openModal();
        }
    },
    openModal() {
        this.open = true;
        document.body.classList.add('overflow-hidden');
    },
    closeModal() {
        this.open = false;
        document.body.classList.remove('overflow-hidden');
    }
}));

Alpine.data('podcastList', () => ({
	expanded: false,
	bg: false,
	// Object form, so Alpine removes the class again rather than only adding it. The collapsed
	// class is server-rendered too, so the overflow episodes never flash in before Alpine boots.
	get gridClass() {
		return { 'podcast-grid--collapsed': !this.expanded };
	},
	get buttonClass() {
		return { 'hidden': this.expanded };
	},
	// Unlike the pale blue sections, this one fades a dark background in, so the text has to
	// cross-fade with it or "Meer weergeven" ends up purple on purple. transition-colors
	// animates color and background-color together.
	get sectionClass() {
		return {
			'bg-secondary': this.bg,
			'bg-secondary/0': !this.bg,
			'text-white': this.bg,
			'text-secondary': !this.bg
		};
	},
	showAll() {
		this.expanded = true;
	},
	showBackground() {
		this.bg = true;
	},
	hideBackground() {
		this.bg = false;
	}
}));

Alpine.start();

registerMediaCarousels();

// const nav = document.getElementById('header');
// if (nav) {
//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach(e => {
//             if (e.isIntersecting) {
//                 nav.classList.toggle('text-white', e.target.dataset.navTheme === 'light');
//                 nav.classList.toggle('text-current', e.target.dataset.navTheme !== 'light');
//             } else {
//                 nav.classList.remove('text-white');
//                 nav.classList.add('text-current');
//             }
//         });
//     }, { 
//         rootMargin: "0px",
//         scrollMargin: "0px",
//         threshold: 1.0, 
//     });

//     document.querySelectorAll('[data-nav-theme]').forEach(s => observer.observe(s));
// }
